import { useCallback, useEffect, useState } from 'react'

import { userAssignmentCodes } from '../api/services/user_assignment_codes'
import { UserCode } from '../api/services/user_assignment_codes/types.ts'
import { MultiOption } from '../components/common/forms/selectInputs/SelectInputs.tsx'

export const useUserAssignmentCode = () => {
  const [loading, setLoading] = useState(false)
  const [options, setOptions] = useState<MultiOption[] | null>(null)
  const [inputs, setInputs] = useState<string[] | null>([])
  const [callDone, setCallDone] = useState(false)
  const [userCodes, setUserCodes] = useState<UserCode[] | null>(null)

  const fetchData = useCallback(async () => {
    try {
      setLoading(true)
      const data: UserCode[] = await userAssignmentCodes.getCodes()
      setUserCodes(data)
      const codeNames = data.map((code) => code.code)
      setOptions(
        codeNames.map((code, index) => {
          return {
            value: `${index + 1}`,
            text: code,
            field: code,
            selected: false
          }
        })
      )
      setInputs(
        codeNames.map((_, index) => {
          return `${index + 1}`
        })
      )
      setCallDone(true)
    }
    catch {
      setOptions([])
    }
    finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (!callDone) fetchData()
  }, [])

  return { userCodes, options, inputs, loading }
}
